export const NUMBER_OF_COMMENTS_TO_FETCH = 10
export const NUMBER_OF_PREVIEW_COMMENTS = 2
